/** Paths that must return after login even when user has no tasks/templates yet. */
export const PRIORITY_RETURN_PATH_PREFIXES = [
    '/app/secure/tickets',
    '/app/ticket/',
]

export const isPriorityReturnUrl = returnUrl => {
    if (!returnUrl) return false
    try {
        const path = decodeURIComponent(returnUrl)
        return PRIORITY_RETURN_PATH_PREFIXES.some(prefix =>
            path.startsWith(prefix),
        )
    } catch {
        return false
    }
}

export const shouldHonorReturnUrl = (
    returnUrl,
    { hasTasks = false, hasTemplates = false } = {},
) => {
    if (!returnUrl) return false
    return isPriorityReturnUrl(returnUrl) || hasTasks || hasTemplates
}

export const buildSignInUrlWithReturn = (pathname, search = '') => {
    const returnUrl = encodeURIComponent(`${pathname}${search || ''}`)
    return `/sign-in?returnUrl=${returnUrl}`
}

export const navigateToReturnUrlOrFallback = (
    navigate,
    returnUrl,
    fallback,
) => {
    if (returnUrl && shouldHonorReturnUrl(returnUrl, fallback.checks)) {
        const decodedUrl = decodeURIComponent(returnUrl)
        try {
            if (decodedUrl.startsWith('/app/task')) {
                sessionStorage.setItem('shouldRedirectIfNoTasks', '1')
            } else {
                sessionStorage.removeItem('shouldRedirectIfNoTasks')
            }
        } catch {
            // ignore storage errors
        }
        navigate(decodedUrl)
        return true
    }
    fallback.run()
    return false
}
